<style lang="stylus">
.label {
  background-color: #e8e8e8;
  color: #191919;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  /* Aether sends hyphenated prefixes ("NTR-100"), which a narrow chip would break in two. */
  white-space: nowrap;
}

/* Countdown under the transcript CTA (Figma 1250-9209: 12px regular, gray-3). */
.transcript-days-left {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #747474;
}

/* Expired-course CTA (Figma 1252-13233). A real <button disabled> so it shares
   the box model, focus/keyboard semantics and disabled announcement of the
   other CTAs — the UA styles below are reset so it still matches the design. */
.access-no-longer-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 4px 24px;
  border: none;
  border-radius: 100px;
  background: #747474;
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;
  white-space: nowrap;
  cursor: not-allowed;
}

/* Browsers grey out disabled buttons; keep the designed colours. */
.access-no-longer-pill:disabled {
  opacity: 1;
  background: #747474;
  color: #fff;
  -webkit-text-fill-color: #fff;
}

/* Full width below 960px, matching every other card CTA at those widths -
   left at content width it was the only button not filling its row. Above
   that it sits at content width, right-aligned via text-sm-right on its
   column (which beats `.button { text-align: center }`). */
@media (max-width: 959px) {
  .access-no-longer-pill {
    width: 100%;
  }
}


.course-description-sub-section {
  color: black;
  font-weight: 600;
}

.anchor-2 {
  border-bottom: 1px solid #8c1d40;
  color: #8c1d40 !important;
}

.courseHistory {
  // Card wrapper styling
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 24px;
  img {
    // width: 50px;
    // height: 50px;
  }

  @media (min-width: 600px) {
    .button {
      text-align: center;
    }
  }

  p {
    margin-bottom: 0px;

    strong {
      font-weight: 600;
    }

    &.grey {
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      color: white;
      text-align: center !important;
      border-radius: 4px;
    }
  }

  .sub-items {
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 1px;

    &.grey {
      background-color: rgb(153, 153, 153);
      padding: 4px 11px;
      color: white;
      border-radius: 0px;
    }
  }

  .label {
    font-size: 11px;

    @media (max-width: 600px) {
      font-size: 11px;
    }
  }

  .label_heads {
    text-transform: uppercase;
    color: #777777;
    letter-spacing: 0.1em;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.91px;
  }

  .alertMdScreens {
    padding: 12px 10px;
    border-radius: 2px;

    i {
      font-size: 14px;
    }
  }

  @media (min-width: 1200px) and (max-width: 1263px) {
    font-size: 16px;
  }

  .options {
    min-width: 120px;
    padding: 0 20px;
    font-weight: 600;
    font-size: 16px;
    border: 1px solid #2a2a2a;
    border-radius: 50px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    color: #2a2a2a;

    .v-icon {
      font-size: 20px;
      margin-left: 4px;
    }

    &.options-mobile {
      width: 100%;
      min-width: unset;
    }
  }

  .calcGPA-mobile {
    width: 100% !important;
    min-width: unset !important;
  }

  .pw-button {
    text-align: end;
    padding-right: 1rem;

    @media (max-width: 1025px) {
      padding-left: 0rem;
    }

    @media (max-width: 780px) {
      padding-left: 6rem;
    }

    @media (max-width: 600px) {
      padding-left: 0rem;
    }
  }

  .courseDetails {
    width: 146px;
    font-weight: 600;
    font-size: 16px;
    border: 2.5px solid;
    border-radius: 50px;
    border-color: #D0D0D0;
    padding: 7px 0px;
    height: 43px;

    @media (min-width: 960px) and (max-width: 1264px) {
      width: 136px;
      font-size: 16px;
      padding: 7px 0px;
    }

    @media (min-width: 600px) and (max-width: 960px) {
      width: 140px;
      margin-left: 3px;
    }

    @media (max-width: 600px) {
      width: 140px;
      padding: 7px 0px;
      font-size: 16px;
    }

    @media (max-width: 380px) {
      width: 140px;
      font-size: 16px;
      padding: 7px 0px;

      .v-icon {
        font-size: 13px;
      }
    }
  }

  .enrollButton {
    width: 115px;
    font-weight: 600;
    font-size: 16px;
    border: 2.5px solid;
    border-radius: 23px;
    border-color: #fec627;
    background: #fec627;
    padding: 5px 0px;
    height: 36px;

    @media (max-width: 600px) {
      width: 115px;
      font-size: 16px;
      padding: 6px 0px;
    }
  }

  .pw-transcript {
    width: 160px;
    font-weight: 600;
    font-size: 16px;
    height: 40px;
    border: 2.5px solid;
    border-radius: 50px;
    border-color: #fec627;
    padding: 6px 0px;

    @media (min-width: 960px) and (max-width: 1264px) {
      width: 145px;
      font-size: 14px;
      padding: 6px 6px;
    }

    @media (max-width: 600px) {
      width: 165px;
      padding: 5px 0px;
    }

    @media (max-width: 375px) {
      width: 170px;
      padding: 5px 11px;
      height: 39px;
    }

    @media (max-width: 320px) {
      width: 160px;
      padding: 5px 11px;
      height: 35px;
      font-size: 14px;
    }
  }

  .calcGPA {
    min-width: 160px;
    padding: 0 24px;
    font-weight: 600;
    font-size: 16px;
    height: 36px;
    border-radius: 50px;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &.unavailable {
      background-color: #e0e0e0 !important;
      border: 1px solid rgb(158, 158, 158);
      cursor: default;

      span {
        color: rgb(158, 158, 158) !important;
      }
    }
  }

  button:focus {
    outline: none;
  }

  .unavailable {
    background-color: #e0e0e0 !important;
    cursor: default !important;
    color: rgb(158, 158, 158) !important;
  }
}

.calcGPATranscript {
  width: 181px;
  font-weight: 600;
  font-size: 16px;
  padding: 9px 0px;
  height: 43px;
  border-radius: 23px;

  @media (max-width: 600px) {
    width: 165px;
  }
}

.displayInfo {
  text-align: justify;

  a {
    color: #2895bc;
  }
}

.fullCourseDetails {
  color: #099fda;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 600;
}

.arrow-up {
  width: 0;
  height: 0px;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 15px solid rgb(254, 198, 39);
  /* position: absolute; */
  margin-top: 4px;
  margin-left: 26px;

  @media (width: 1440px) {
    margin-left: 15px;
  }
}

.warning-symbol {
  margin-left: 0px !important;
}

@media (max-width: 600px) {
  .arrow-up {
    margin-top: 4px;
    margin-left: 14px !important;
  }

  .mobileDisplaynone {
    display: none !important;
  }
}

@media (min-width: 600px) and (max-width: 960px) {
  .warning-symbol {
    margin-left: 0px !important;
  }

  .arrow-up {
    margin-left: 14px !important;
  }
}

.theme--light .v-alert__icon {
  color: white !important;
}

@media only screen and (max-width: 600px) {
  .v-alert.alertMdScreens {
    width: 100% !important;
  }
}

@media (min-width: 700px) and (max-width: 860px) {
  .v-alert.alertMdScreens {
    width: 100% !important;
  }
}

@media (min-width: 960px) and (max-width: 1263px) {
  .v-alert.alertMdScreens {
    width: 30rem !important;
  }
}

.v-alert.alertMdScreens {
  margin: 0 !important;
  width: 32rem;
}

#app > div.v-dialog__content.v-dialog__content--active {
  z-index: 1000 !important;
}

.icon-border-round {
  border: 1px solid @bordercolor;
  border-color: #d9d9d9;
  padding: 0.2em;
  border-radius: 50%;
}

.honor-credits {
  font-size: 11px;
  background-color: #FFC627;
  padding: 4px 8px;
  border-radius: 2.5px;
  font-weight: bold;
}

.backColor {
  color: black;
  width: 100%;
}

.button-check {
  font-size: 45px !important;

  @media (max-width: 480px) {
    font-size: 3rem !important;
    padding-left: 2rem;
  }
}

.coursesAdd {
  background-color: #f1f1f1;
  color: white;
  padding: 6px;
  border-radius: 2px 2px 0px 0px;
  height: 40px;

  @media (min-width: 1024px) and (max-width: 1264px) {
    height: 60px;
  }

  @media (max-width: 600px) {
    height: 70px;
  }

  @media (max-width: 480px) {
    height: 8.5rem;
  }

  .courseTitle {
    font-size: 16px;
    padding: 1px 0px 1px 25px !important;

    @media (min-width: 1024px) and (max-width: 1264px) {
      padding: 1px 0px 0px 0px !important;
    }

    @media (min-width: 960px) and (max-width: 1023px) {
      padding: 1px 36px !important;
    }

    @media (min-width: 600px) and (max-width: 960px) {
      padding: 1px 0px 0px 25px !important;
    }

    @media (min-width: 320px) and (max-width: 480px) {
      padding: 1px 0px 1px 13px !important;
    }
  }
}

.courses {
  background-color: transparent;
  color: #191919;
  gap: 12px;

  @media (max-width: 600px) {
    gap: 4px;
  }
}

.course-title {
  font-size: 16px;
  font-weight: 600;
  color: #191919;
}

.weight-100 {
  @media (min-width: 1264px) {
    max-width: 100% !important;
  }

  @media (min-width: 0) {
    max-width: 100% !important;
  }
}

.courseLayout {
  text-align: center;
  border: none;
  background-color: transparent;
  padding: 0;

  .auditCourse {
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    color: #191919;

    @media (max-width: 1024px) {
      font-size: 12px;
    }

    @media (max-width: 600px) {
      font-size: 15px;
    }

    @media (max-width: 320px) {
      font-size: 12px;
    }
  }
}

.pw-courses {
  padding-bottom: 4px;
  color: #191919;
  font: normal normal bold 14px / 23px Roboto;
  white-space: nowrap;
  text-align: right;

  @media (max-width: 600px) {
    text-align: left;
    padding-left: 0;
    padding-bottom: 0;
    font-size: 12px;
    line-height: 1.4;
  }

  .check-icon {
    font-size: 14px !important;
    color: #191919 !important;
    padding-right: 6px;

    @media (min-width: 600px) and (max-width: 780px) {
      font-size: 13px !important;
    }

    @media (max-width: 600px) {
      font-size: 14px;
    }
  }
}

.options-in-add-courses .calcGPA {
  @media (min-width: 358px) and (max-width: 362px) {
    width: 154px;
    font-weight: 600;
    font-size: 16px;
    height: 43px;
  }

  @media (min-width: 373px) and (max-width: 377px) {
    width: 154px;
    font-weight: 600;
    font-size: 16px;
    height: 43px;
  }
}

.options-in-add-courses {
  @media (min-width: 358px) and (max-width: 362px) {
    width: 120px;
    font-weight: 600;
    font-size: 16px;
    height: 43px;
  }

  @media (min-width: 373px) and (max-width: 377px) {
    width: 120px;
    font-weight: 600;
    font-size: 16px;
    height: 43px;
  }
}

.button-space {
  @media (min-width: 1278px) {
    margin: auto auto auto 16px;
  }
}

.button-adjust {
  @media (min-width: 342px) and (max-width: 362px) {
    margin-right: -12px !important;
  }
}

.weight-100 .align-self-center {
  align-self: auto;
}

.button-min-width {
  min-width: 180px;
}

.btn-add-courses {
  min-width: 160px;
}

.mb-view {
  @media only screen and (max-width: 599px) {
    flex-direction: column !important;
  }
}

.mb-views {
  @media only screen and (max-width: 599px) {
    margin-right: 0px !important;
  }
}

.xl-marginleft {
  @media (min-width: 1900px) {
    margin-left: 6rem !important;
  }
}

.close-button {
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
}

.modal-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  span {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
  }

  .alert-icon {
    font-size: 40px;
    color: #CC2F2F;
  }
}

.action-btn-group {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.underline-link {
  transition: color 0.1s;

  &:hover {
    color: #095B79;
    box-shadow: 0 1.5px 0 #095B79;
  }
}

.add-courses-button-offset {
  @media (min-width: 600px) {
    margin-top: -10px;
  }
}
</style>

<template>
  <div style="position: relative" :style="{ marginBottom: isLastCourse ? '0' : '16px' }">
    <div class="courseHistory">
      <!-- The Course Prefix and Warning label -->
      <v-col cols="12" sm="12" lg="12" xl="12" style="padding: 0px">
        <!-- Desktop header layout (non add-courses) -->
        <div class="courses d-none d-sm-flex align-center" v-if="from !== 'add-courses'">
          <div class="label">{{ coursePrefixDisplayLabel || coursePrefix }}</div>
          <strong class="course-title text-truncate" style="flex: 1; min-width: 0">{{ title }}</strong>
          <span v-if="from === 'dashboard' && isPathwayCourse" class="pw-courses ms-2 flex-shrink-0">
            <v-icon class="check-icon">mdi-check-circle</v-icon>Aligns with your pathway
          </span>
          <UiBadge
            v-if="transcriptTag"
            size="tag"
            tone="subtle"
            :variant="transcriptTag.variant"
            :icon="transcriptTag.icon"
            class="ms-2 flex-shrink-0"
            >{{ transcriptTag.text }}</UiBadge
          >
        </div>
        <!-- Mobile header layout (non add-courses) -->
        <div class="courses d-flex d-sm-none flex-column align-start" v-if="from !== 'add-courses'">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="label">{{ coursePrefixDisplayLabel || coursePrefix }}</div>
            <UiBadge
              v-if="transcriptTag"
              size="tag"
              tone="subtle"
              :variant="transcriptTag.variant"
              :icon="transcriptTag.icon"
              class="flex-shrink-0"
              >{{ transcriptTag.text }}
            </UiBadge>
          </div>
          <strong class="course-title" style="font-size: 16px; margin-bottom: 2px">{{ title }}</strong>
          <span v-if="from === 'dashboard' && isPathwayCourse" class="pw-courses">
            <v-icon class="check-icon">mdi-check-circle</v-icon>Aligns with your pathway
          </span>
        </div>

        <!-- Divider (non add-courses) -->
        <v-divider
          v-if="from !== 'add-courses'"
          :class="$vuetify.display.xs ? 'my-2' : 'my-3'"
          style="border-color: #e0e0e0; opacity: 1"
        />

        <!-- Course Prefix and Course Name head section Start (Add Courses page) -->
        <!-- Desktop header layout for add-courses -->
        <div class="courses d-none d-sm-flex align-center" v-if="from === 'add-courses'">
          <div class="label">{{ coursePrefixDisplayLabel || coursePrefix }}</div>
          <strong class="course-title text-truncate" style="flex: 1; min-width: 0">{{ title }}</strong>
          <span v-if="isPathwayCourse" class="pw-courses ms-2 flex-shrink-0">
            <v-icon class="check-icon">mdi-check-circle</v-icon>Aligns with your pathway
          </span>
        </div>
        <!-- Mobile header layout for add-courses -->
        <div class="courses d-flex d-sm-none flex-column align-start" v-if="from === 'add-courses'">
          <div class="label">{{ coursePrefixDisplayLabel || coursePrefix }}</div>
          <strong class="course-title" style="font-size: 16px; margin-bottom: 2px">{{ title }}</strong>
          <span v-if="isPathwayCourse" class="pw-courses">
            <v-icon class="check-icon">mdi-check-circle</v-icon>Aligns with your pathway
          </span>
        </div>

        <!-- Divider for add-courses -->
        <v-divider
          v-if="from === 'add-courses'"
          :class="$vuetify.display.xs ? 'my-2' : 'my-3'"
          style="border-color: #e0e0e0; opacity: 1"
        />
        <!-- Course Prefix and Course Name head section End -->
        <!-- Course Details section Start -->
        <v-row no-gutters justify-space-between wrap>
          <div class="backColor">
            <div class="courseLayout">
              <v-row no-gutters class="ma-0 pa-0">
                <!-- Course Start/End Dates and Credits Section start  -->
                <!-- sm = 12 so the details and the CTAs become two clean full-width
                     rows on tablets instead of a half-width ragged stack. md must
                     stay 6 to match the CTA column beside it: at md=12 the details
                     filled the row and pushed the CTA onto a second line, where
                     justify-end left it stranded mid-card. -->
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" :class="$vuetify.display.smAndDown ? 'mb-3' : ''">
                  <p class="auditCourse font-weight-bold" v-if="isAudit">
                    <v-icon
                      color="rgb(0, 164, 230)"
                      style="font-size: 14px; cursor: pointer; padding-bottom: 2px; margin-right: 8px; display: none"
                      light
                      >mdi-bullhorn</v-icon
                    >Learn how this platform and program work.
                  </p>
                  <v-row no-gutters wrap class="">
                    <v-col cols="12" sm="12" md="12">
                      <v-row no-gutters justify-start wrap>
                        <v-col
                          :cols="labelSectionCols"
                          sm="4"
                          md="4"
                          lg="4"
                          v-for="(item, index) in label_sections"
                          v-bind:key="item.key"
                          :style="{ textAlign: labelSectionAlign(index) }"
                        >
                          <div class="label_heads" :class="item.key === 'grade' ? 'pl10' : ''">
                            {{ item.key }}
                          </div>
                          <span class="sub-items" :class="item.key === 'grade' ? 'grey' : ''">{{ item.value }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- Course Start/End Dates and Credits Section end  -->
                <!-- Empty space -->
                <v-col cols="6" md="3" v-if="from == 'checkout'" class="align-self-center text-xs-center" />
                <!-- Course Details/Add Course/Options/Access Course/Upgrade/Add to Transcript/View Course Results/Enroll Buttons Section Start -->
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="align-self-end pa-0">
                  <!-- No flex-nowrap: at md this column is only half the card (and the
                       panel is itself md=8), too narrow for Options + a min-width 180px
                       CTA, so a forced single line overflowed left onto the credits
                       column (ULC-3265). Wrapping only engages when they don't fit. -->
                  <v-row
                    no-gutters
                    class="flex-column flex-sm-row justify-end align-start align-sm-center"
                    :class="{ 'align-end': !$vuetify.display.smAndUp }"
                    style="gap: 12px"
                  >
                    <!-- Options button for dashboard -->
                    <v-col
                      cols="12"
                      sm
                      md="auto"
                      class="pa-0 text-right text-sm-left"
                      :style="{ order: $vuetify.display.xs ? 0 : 0 }"
                      v-if="
                        isFromCourseHistoryAndAddToTranscript &&
                        buttonLabel !== 'Add to Transcript' &&
                        hasOptionsMenuItems
                      "
                    >
                      <!-- min-width auto: v-menu otherwise stretches to the activator's
                           width. The shadow comes from .asu-menu, so no elevation class. -->
                      <v-menu v-model="collapsed" offset-y min-width="auto">
                        <template v-slot:activator="{ props }">
                          <button
                            class="options mobile-touch-target"
                            :class="{ 'options-mobile': $vuetify.display.smAndDown }"
                            v-if="!isSelected"
                            flat
                            v-bind="props"
                            @click.stop="
                              asuoDataLayerClick('MyCourses', '2', {
                                section: title
                              })
                            "
                            title="Course details or Unenroll"
                          >
                            Options
                            <v-icon style="font-weight: 900">{{
                              collapsed ? 'mdi-chevron-up' : 'mdi-chevron-down'
                            }}</v-icon>
                          </button>
                        </template>

                        <v-list class="asu-menu asu-menu--compact">
                          <v-list-item
                            v-if="!!courseDescription"
                            @click="
                              collapsed = !collapsed;
                              displayInformation();
                              openDetails();
                              asuoDataLayerClick('MyCourses', '1', {
                                region: 'main content',
                                section: title,
                                action: 'open',
                                event: 'select',
                                type: 'select options'
                              });
                            "
                            class="asu-menu__item"
                          >
                            <template v-slot:prepend>
                              <v-icon size="20">mdi-information-outline</v-icon>
                            </template>
                            <v-list-item-title class="asu-menu__label">Course details</v-list-item-title>
                          </v-list-item>

                          <v-divider v-if="!!courseDescription && unenroll" style="margin: 0" />

                          <v-list-item
                            v-if="unenroll"
                            @click="
                              collapsed = !collapsed;
                              unenrollCourse = !unenrollCourse;
                              doUnenroll($event);
                              asuoDataLayerClick('MyCourses', '0', {
                                region: 'main content',
                                section: title,
                                text: 'unenroll'
                              });
                              captureEcomDataLayer('remove_from_cart');
                            "
                            class="asu-menu__item"
                          >
                            <template v-slot:prepend>
                              <v-icon size="20">mdi-delete</v-icon>
                            </template>
                            <v-list-item-title class="asu-menu__label">
                              <span v-if="buttonAction === 'Enroll and pay' && enrollmentMode === 'honor'"
                                >Remove course</span
                              >
                              <span v-else>Unenroll</span>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>

                    <!-- Course Details Button for Dashboard Start -->
                    <v-col
                      cols="6"
                      sm="5"
                      md="6"
                      lg="6"
                      xl="6"
                      v-if="from == 'dashboard' && buttonLabel == 'Add to Transcript'"
                      class="button align-self-end"
                      style="display: none"
                    >
                      <button
                        @click="
                          displayInformation();
                          asuoDataLayerClick('MyCourses', '1', {
                            region: 'main content',
                            section: title,
                            action: 'open'
                          });
                        "
                        v-if="!!courseDescription"
                      >
                        <div class="courseDetails">
                          <span>Course Details</span>
                        </div>
                      </button>
                    </v-col>
                    <!-- Course Details Button for Dashboard End -->

                    <!-- Course Details Button for AddCourses Start -->
                    <v-col
                      cols="12"
                      sm
                      md="auto"
                      class="pa-0 text-right text-sm-left"
                      v-if="from == 'add-courses' && !!courseDescription"
                    >
                      <button
                        class="options"
                        :class="{ 'options-mobile': $vuetify.display.smAndDown }"
                        @click="
                          displayInformation();
                          asuoDataLayerClick('MyCourses', '1', {
                            region: 'main content',
                            section: title,
                            action: 'open'
                          });
                        "
                      >
                        Course Details
                      </button>
                    </v-col>
                    <!-- Course Details Button for AddCourses End -->

                    <!-- Course Details Button for Pathways Start -->
                    <v-col
                      cols="5"
                      sm="11"
                      md="4"
                      lg="12"
                      v-if="
                        from == 'pathways' &&
                        buttonLabel != 'Add to Transcript' &&
                        buttonLabel != 'View Transcript' &&
                        courseSection != 'Courses in Progress' &&
                        courseSubSection != 'Not open' &&
                        !isNonEnrollableCourse
                      "
                      class="pw-button align-self-start"
                    >
                      <button
                        @click="
                          displayInformation();
                          asuoDataLayerClick('MyCourses', '1', {
                            region: 'main content',
                            section: title,
                            action: 'open'
                          });
                        "
                        v-if="!!courseDescription"
                      >
                        <div class="courseDetails" v-if="!originalSelection">
                          <span>Course Details</span>
                        </div>
                      </button>
                    </v-col>
                    <!-- Course Details Button for Pathways End -->
                    <v-col
                      cols="5"
                      sm="5"
                      md="7"
                      lg="7"
                      xl="7"
                      v-if="
                        from === 'pathways' && buttonLabel !== 'Add to Transcript' && courseSubSection === 'Open now'
                      "
                    >
                      <button
                        @click="
                          displayInformation();
                          asuoDataLayerClick('MyCourses', '1', {
                            region: 'main content',
                            section: title,
                            action: 'open'
                          });
                        "
                        v-if="!!courseDescription"
                      >
                        <div class="courseDetails">
                          <span>Course Details</span>
                        </div>
                      </button>
                    </v-col>
                    <!-- Course Details Button For Pathways End -->
                    <!-- Course Details button End -->
                    <!-- Add to transcript/Upgrade/Enroll/Access Course Button Section Start -->
                    <v-col
                      cols="12"
                      sm
                      md="auto"
                      class="pa-0 text-right text-sm-left"
                      :style="{ order: $vuetify.display.xs ? 1 : 1 }"
                    >
                      <!-- The button area for Dashboard and Course history -->
                      <div
                        v-if="
                          (from == 'dashboard' || from == 'course-history' || from == 'pathways') &&
                          isFromCourseHistoryAndAddToTranscript
                        "
                        class="button"
                        style="text-align: right"
                      >
                        <button
                          v-if="getButtonLabel === 'Access no longer available'"
                          type="button"
                          disabled
                          class="access-no-longer-pill"
                        >
                          {{ accessNoLongerLabel }}
                        </button>
                        <button
                          @click="
                            ctaCourseEnrollmentAction();
                            trackCtaButtonClick();
                          "
                          v-else-if="isFromCourseHistoryAndAddToTranscript"
                          :disabled="creditPendingOrHold"
                          :class="{ 'w-100': $vuetify.display.smAndDown }"
                        >
                          <div
                            class="calcGPA button-min-width mobile-touch-target"
                            :class="[
                              unavailableClass,
                              creditPendingOrHold ? 'unavailable' : '',
                              $vuetify.display.smAndDown ? 'calcGPA-mobile' : ''
                            ]"
                            v-if="buttonLabel"
                            :style="buttonStyles"
                          >
                            <span>{{ getButtonLabel }}</span>
                          </div>
                        </button>
                        <div
                          v-if="buttonLabel == 'Enroll and pay' && isIdVerificationDeadlineInFuture"
                          :class="$vuetify.display.xs ? 'text-center' : 'text-right'"
                          style="margin-top: 2px; margin-bottom: -12px"
                        >
                          <span style="font-size: 12px; font-weight: normal; color: #747474">{{
                            enrollDeadlineText
                          }}</span>
                        </div>
                        <!-- Centred under the CTA (Figma 1250-9209 stacks them
                             items-center); right-aligning drifted it to the
                             container edge once the button went full width. -->
                        <div
                          v-if="transcriptDaysLeftText"
                          class="text-center transcript-days-left"
                          style="margin-top: 2px; margin-bottom: -12px"
                        >
                          {{ transcriptDaysLeftText }}
                        </div>
                      </div>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-if="(from == 'course-history' || from == 'pathways' || from == 'dashboard') && isPastCourse"
                        class="button align-self-center pa-0 text-sm-right"
                        style="margin-bottom: 5px"
                      >
                        <button
                          v-if="shouldShowCourseResultButtonForStandardCourse || shouldShowViewCourseForAudit"
                          @click="
                            openCourse();
                            navigateToURL(progressPageURL);
                            asuoDataLayerClick('MyCourses', '4', {
                              region: 'main content',
                              section: title
                            });
                          "
                        >
                          <div
                            class="calcGPA button-min-width"
                            v-if="shouldShowCourseResultButtonForStandardCourse || shouldShowViewCourseForAudit"
                            :class="unavailableClass"
                            style="width: 192px"
                          >
                            <span>View course results</span>
                          </div>
                        </button>
                        <button v-if="shouldShowAccessNoLonger" type="button" disabled class="access-no-longer-pill">
                          {{ accessNoLongerLabel }}
                        </button>
                      </v-col>

                      <!-- The button area for Add Courses Start -->

                      <v-col cols="12" sm md="auto" class="pa-0 text-right text-sm-left" v-if="from == 'add-courses'">
                        <button
                          @click="
                            addCourseAction(coursePrefix, courseStartDate, courseOfferingId);
                            asuoDataLayerClick('MyCourses', '3', {
                              region: 'main content',
                              section: title,
                              text: isSelected ? 'Remove Course' : 'Add Course',
                              type: 'click'
                            });
                          "
                          :class="{ 'w-100': $vuetify.display.smAndDown }"
                        >
                          <!-- Transcripted state -->
                          <div
                            v-if="isCourseTranscripted"
                            class="calcGPA unavailable"
                            :class="{ 'w-100': $vuetify.display.smAndDown }"
                          >
                            <span>Transcripted</span>
                          </div>

                          <!-- Non-enrollable course -->
                          <div
                            v-else-if="isNonEnrollableCourse"
                            class="calcGPA unavailable"
                            :class="{ 'w-100': $vuetify.display.smAndDown }"
                          >
                            <span>{{ buttonLabel }}</span>
                          </div>

                          <!-- Add Course button (maroon filled) -->
                          <div
                            class="calcGPA"
                            v-else-if="!isSelected && addCourseButton()"
                            :class="{ 'w-100': $vuetify.display.smAndDown }"
                            style="background-color: #8c1d40; color: #ffffff"
                            @click="captureEcomDataLayer('add_to_wishlist')"
                          >
                            <span
                              ><v-icon color="white" style="font-size: 16px; padding: 4px">mdi-plus</v-icon>Add
                              Course</span
                            >
                          </div>

                          <!-- Prereq Required state -->
                          <div
                            class="calcGPA unavailable"
                            v-else-if="preRequiredButton()"
                            :class="{ 'w-100': $vuetify.display.smAndDown }"
                          >
                            <span>Prereq Required</span>
                          </div>

                          <!-- Enrolled/Scheduled state -->
                          <div
                            v-else-if="originalSelection"
                            class="calcGPA unavailable"
                            :class="{ 'w-100': $vuetify.display.smAndDown }"
                          >
                            <div v-if="buttonAction !== 'Enroll and pay' && enrollmentMode !== 'honor'">
                              <span>Enrolled</span>
                            </div>
                            <div v-else>
                              <span>Scheduled</span>
                            </div>
                          </div>

                          <!-- Selected state (checkmark) -->
                          <div
                            v-else
                            class="calcGPA"
                            :class="{ 'w-100': $vuetify.display.smAndDown }"
                            style="background-color: #ffc627; color: #000"
                            @click="captureEcomDataLayer('remove_from_cart')"
                          >
                            <v-icon color="black" size="20">mdi-check</v-icon>
                            <span style="margin-left: 4px">Selected</span>
                          </div>
                        </button>
                      </v-col>
                      <!-- The button area for Add Courses End -->

                      <!-- BUTTONS FOR RESET COURSE -->
                      <v-col
                        cols="12"
                        sm="3"
                        md="12"
                        v-if="
                          from == 'course-history' &&
                          (courseInfo._isCourseResetRequested ||
                            (courseResetAllowed() && !isFromCourseHistoryAndAddToTranscript))
                        "
                        class="button align-self-center pa-0"
                        style="margin-bottom: 5px"
                      >
                        <button v-if="courseInfo._isCourseResetRequested">
                          <div
                            class="calcGPA unavailable button-min-width"
                            :class="unavailableClass"
                            style="width: 192px"
                          >
                            <span>Reset pending</span>
                          </div>
                        </button>
                        <button
                          @click="openModal"
                          v-else-if="courseResetAllowed() && !isFromCourseHistoryAndAddToTranscript"
                        >
                          <div class="calcGPA button-min-width" :class="unavailableClass" style="width: 192px">
                            <span>Reset course</span>
                          </div>
                        </button>
                      </v-col>
                      <!-- Add To Transcript Button Area For Pathway End -->

                      <!-- Enroll Button For Pathways Start -->
                      <v-col
                        cols="6"
                        sm="12"
                        md="12"
                        v-if="from == 'pathways' && courseSubSection == 'Open Now'"
                        class="button align-self-end"
                      >
                        <button
                          @click="
                            pathwayCourses(coursePrefix, courseStartDate);
                            asuoDataLayerClick('MyCourses', '3', {
                              region: 'main content',
                              section: title,
                              text: 'Enroll',
                              type: 'click'
                            });
                          "
                        >
                          <div class="enrollButton button-min-width">
                            Enroll
                            <v-icon
                              left
                              style="color: black; position: relative; margin-right: 0px; padding: 0px 0px 0px 4px"
                              >mdi-arrow-right</v-icon
                            >
                          </div>
                        </button>
                      </v-col>
                      <!-- Enroll Button For Pathways End -->

                      <!-- Course Details Button For Pathways Start -->
                      <v-col
                        cols="5"
                        sm="11"
                        md="4"
                        lg="12"
                        v-if="
                          (from !== 'pathways' &&
                            buttonLabel !== 'Add to Transcript' &&
                            courseSection == 'Courses in Progress') ||
                          courseSubSection == 'Not open'
                        "
                        class="pw-button align-self-end"
                      >
                        <button
                          @click="
                            openDetails();
                            displayInformation();
                            asuoDataLayerClick('MyCourses', '1', {
                              region: 'main content',
                              section: title,
                              action: 'open'
                            });
                          "
                          v-if="!!courseDescription"
                        >
                          <div class="courseDetails button-min-width" v-if="!originalSelection">
                            <span>Course Details</span>
                          </div>
                        </button>
                      </v-col>
                      <!-- Course Details Button For Pathways End -->
                    </v-col>
                    <!-- Add to transcript/Upgrade/Enroll/Access Course Button Section End -->

                    <!-- Empty space -->
                    <v-col cols="6" sm="3" md="3" v-if="from == 'checkout'" class="align-self-center text-xs-center" />
                  </v-row>
                </v-col>
                <!-- Course Details/Add Course/Options/Access Course/Upgrade/Add to Transcript/View Course Results/Enroll Buttons Section End -->
              </v-row>

              <!-- Benefits Not Eligible Alert box Start -->
              <!-- One icon pair + one banner for every surface. These used to be
                   duplicated per `from`, which is why adding My Courses meant the
                   warning was simply missing there (ULC-3265). Which surfaces
                   qualify now lives solely in shouldShowWarningAsBenefitsNotEligible,
                   and benefitsAlertOpen keeps each surface's own default state. -->
              <v-col cols="2" class="d-flex d-sm-none justify-center align-center" v-if="showBenefitsWarningIcon">
                <img
                  @click="
                    benefitsAlertOpen = !benefitsAlertOpen;
                    asuoDataLayerClick('MyCourses', '5', { section: title });
                  "
                  src="../assets/icons/exclamation-triangle.png"
                  style="cursor: pointer"
                />
              </v-col>
              <v-col
                cols="1"
                sm="1"
                md="2"
                lg="1"
                xl="1"
                class="d-none d-sm-flex mobileDisplaynone justify-center align-center"
                style="padding: 0px"
                v-if="showBenefitsWarningIcon"
              >
                <img
                  @click="
                    benefitsAlertOpen = !benefitsAlertOpen;
                    asuoDataLayerClick('MyCourses', '5', { section: title });
                  "
                  src="../assets/icons/exclamation-triangle.png"
                  style="cursor: pointer"
                  :style="[benefitsAlertOpen ? { 'padding-bottom': '0px' } : { 'padding-bottom': '18px' }]"
                />
              </v-col>
              <!-- Benefits Not Eligible Alert box End -->

              <v-col cols="12" sm="12" md="11" v-if="showBenefitsWarningIcon && benefitsAlertOpen">
                <div class="arrow-up" style="margin-left: 16px" />
                <v-alert
                  class="alertMdScreens font-weight-bold"
                  closable
                  v-model="benefitsAlertOpen"
                  :icon="false"
                  type="warning"
                  style="border: none; color: black !important; margin-top: 0px; background-color: #fec627 !important"
                  >{{ warningMessageBasedOnCourseType }}</v-alert
                >
              </v-col>
              <!-- Course Description Section Start -->
              <v-row v-if="displayInfo" class="mt-4" style="padding: 7px">
                <v-col cols="12" sm="12" md="12" style="position: relative; background-color: #f1f1f1; font-size: 14px">
                  <div class="displayInfo">
                    <v-row justify-space-between align-center>
                      <v-col cols="9" sm="6" md="6">
                        <div class="course-description-sub-section" style="color: black">Course Description</div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="1" sm="1" md="1" style="position: absolute; right: 5px; margin-right: 0px; top: 5px">
                        <v-icon
                          color="#343434"
                          style="font-size: 15px; margin-left: 10px; margin-right: 10px; margin-bottom: 3px"
                          dark
                          @click="
                            displayInformation();
                            asuoDataLayerClick('MyCourses', '1', {
                              region: 'main content',
                              section: title,
                              action: 'close'
                            });
                            closeModal();
                          "
                          >mdi-close-circle</v-icon
                        >
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        @click="
                          asuoDataLayerClick('MyCourses', '3', {
                            section: title
                          })
                        "
                      >
                        <span style="font-weight: 400; font-size: 12px; color: black">{{ courseDescription }}</span>
                        <div class="mt-4">
                          <v-row wrap justify-space-between align-center>
                            <v-col>
                              <div class="course-description-sub-section">Length</div>
                              <div>{{ courseLength || '--' }}</div>
                            </v-col>
                            <v-col>
                              <div class="course-description-sub-section">Recommended prerequisite</div>
                              <div>{{ coursePrerequisiteLabel || '--' }}</div>
                            </v-col>
                            <v-col>
                              <div class="course-description-sub-section">Hours per week</div>
                              <div>{{ courseEffortPerHour || '--' }}</div>
                            </v-col>
                            <v-col>
                              <div class="course-description-sub-section">Course pacing</div>
                              <div>{{ coursePacing || '-' }}</div>
                            </v-col>
                          </v-row>
                          <!-- <v-col> -->
                          <div class="course-description-sub-section" style="padding-top: 24px">
                            Credit Designation(s)
                          </div>
                          <div ref="mylinediv" v-html="formattedCourseDesignations" />
                          <!-- </v-col> -->
                          <h5 style="margin-top: 10px">
                            <a
                              href="https://catalog.asu.edu/ug_gsr/"
                              target="_blank"
                              class="anchor-2"
                              style="font-size: 14px"
                              >Learn more about credit designations</a
                            >
                          </h5>
                        </div>
                        <v-divider v-if="eaCourseURL" />
                        <button v-if="eaCourseURL" @click="viewFullCourseDetails(eaCourseURL)">
                          <div class="calcGPA" style="padding: 12px 24px; font-weight: 500; width: 100%; height: 100%">
                            <strong style="font-size: 16px">View full course details</strong>
                            <v-icon left style="margin: -4px 6px; font-size: 25px">mdi-arrow-right</v-icon>
                          </div>
                        </button>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <!-- Course Description Section End -->
              <!-- Credit Designation Section Start (Course History only) -->
              <v-row
                v-if="from === 'course-history' && formattedCourseDesignations && formattedCourseDesignations !== '--'"
                no-gutters
                class="mt-4 pa-0"
              >
                <v-col cols="12" class="text-left">
                  <div style="font-size: 12px; color: #747474; font-weight: 500; text-align: left">
                    <span>Credit Designation: </span
                    ><span style="color: #747474" v-html="formattedCourseDesignations" />
                  </div>
                </v-col>
              </v-row>
              <!-- Credit Designation Section End -->
            </div>
          </div>
        </v-row>
        <!-- Course Details section End -->
      </v-col>
    </div>
    <!-- Add to Transcript GPA Calculator Prompt/Popup Start -->

    <v-dialog v-model="addingLowerGradeCourseModal" max-width="464" class="sm-padding">
      <v-card style="padding: 10px">
        <v-card-title class="headline modal-title">
          <v-icon class="alert-icon" size="64">mdi-alert</v-icon>
          <span>{{ eaPathwaysGpaAlert ? 'GPA Requirement Alert' : 'GPA Impact Alert' }}</span>
          <v-spacer />
          <v-icon
            @click="
              addingLowerGradeCourseModal = false;
              eaPathwaysGpaAlert
                ? asuoDataLayerClick('myCoursesGPAImpactModal', '0', {
                    section: 'gpa requirement alert',
                    component: title
                  })
                : asuoDataLayerClick('myCoursesGPAImpactModal', '0', { component: title });
            "
            class="close-button"
            >mdi-close</v-icon
          >
        </v-card-title>

        <v-card-text>
          {{
            eaPathwaysGpaAlert
              ? 'Adding this grade to your transcript could result in your GPA dropping below the 2.75 requirement for general admission to ASU.'
              : 'Adding this grade to your official academic transcript could result in lowering your overall GPA.'
          }}
          <a
            class="underline-link"
            @click="
              eaPathwaysGpaAlert
                ? asuoDataLayerClick('myCoursesGPAImpactModal', '1', {
                    section: 'gpa requirement alert',
                    text: 'earned Admission and pathway to admission',
                    component: title
                  })
                : asuoDataLayerClick('myCoursesGPAImpactModal', '1', { component: title })
            "
            href="https://gpacalculator.io/cumulative-gpa-calculator/"
            target="_blank"
            >Calculate GPA</a
          >
        </v-card-text>

        <v-card-text>
          Need more information?
          <a
            class="underline-link"
            @click="
              eaPathwaysGpaAlert
                ? asuoDataLayerClick('myCoursesGPAImpactModal', '2', {
                    section: 'gpa requirement alert',
                    component: title
                  })
                : asuoDataLayerClick('myCoursesGPAImpactModal', '2', { component: title })
            "
            :href="ulcPartnerFlag ? 'https://ulc.asu.edu/contact-us/' : 'https://ea.asu.edu/contact/'"
            target="_blank"
            >Contact a Success Coach here.</a
          >
        </v-card-text>
        <v-spacer />
        <v-card-actions class="action-btn-group">
          <v-btn
            style="background-color: #8c1d40; color: white"
            round
            text
            large
            @click="
              continueToAddTranscript();
              eaPathwaysGpaAlert
                ? asuoDataLayerClick('myCoursesGPAImpactModal', '3', {
                    section: 'gpa requirement alert',
                    component: title
                  })
                : asuoDataLayerClick('myCoursesGPAImpactModal', '3', { component: title });
            "
            >Yes, add to transcript</v-btn
          >

          <v-btn
            style="background-color: #bfbfbf; color: black"
            round
            text
            large
            @click="
              addingLowerGradeCourseModal = false;
              eaPathwaysGpaAlert
                ? asuoDataLayerClick('myCoursesGPAImpactModal', '4', {
                    section: 'gpa requirement alert',
                    component: title
                  })
                : asuoDataLayerClick('myCoursesGPAImpactModal', '4', { component: title });
            "
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add to Transcript GPA Calculator Prompt/Popup End -->

    <!-- Course Unenroll Prompt/Popup End -->
    <!-- COURSE RESET DIALOG STARTS -->
    <v-dialog v-model="dialog" max-width="720">
      <v-card>
        <v-card-title class="headline course-warning-head-modal" style="padding-left: 24px; padding-right: 24px"
          >Reset Pending</v-card-title
        >
        <v-card-text class="course-warning-message">
          Your course reset has been requested. It can take up to 7-10 business days to be completed. Your course will
          be moved back to the Current Courses section of your learner dashboard once this is complete.
        </v-card-text>
        <div class="course-warning-buttons" style="border-bottom: 5px solid #fec627">
          <v-btn class="warning-yes-button" color="#fec627" :ripple="false" @click="confirmResetCourse()" rounded
            >OK</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- COURSE RESET DIALOG ENDS -->

    <credit-request-from
      v-if="shouldLoadCreditRequestForm"
      :creditRequestRequestUUID="creditRequestRequestUUID"
      :creditRequestTimestamp="creditRequestTimestamp"
      :creditRequestCourseOrg="creditRequestCourseOrg"
      :creditRequestCourseNum="creditRequestCourseNum"
      :creditRequestCourseRun="creditRequestCourseRun"
      :creditRequestEnrollmentTimestamp="creditRequestEnrollmentTimestamp"
      :creditRequestCourseCompletionTimestamp="creditRequestCourseCompletionTimestamp"
      :creditRequestFinalGrade="creditRequestFinalGrade"
      :creditRequestUserUsername="creditRequestUserUsername"
      :creditRequestUserEmail="creditRequestUserEmail"
      :creditRequestUserFullName="creditRequestUserFullName"
      :creditRequestUserMailingAddress="creditRequestUserMailingAddress"
      :creditRequestUserCountry="creditRequestUserCountry"
      :creditRequestSignature="creditRequestSignature"
    />

    <!-- Parent Consent Modal -->
    <parent-consent-modal
      :show="showParentConsentModal"
      :student-name="getLearnerData?._firstName + ' ' + getLearnerData?._lastName"
      :transaction-fee="
        ['Upgrade', 'UpgradeModal', 'Enroll and pay'].indexOf(buttonAction) >= 0
          ? 'enrollment fee'
          : 'credit conversion fee'
      "
      @update:show="showParentConsentModal = $event"
      @consent="handleParentConsent"
      @cancel="handleParentConsentCancel"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useUserStore } from '@/stores/user';
import { useCheckoutStore } from '@/stores/checkout';
import { isFeatureEnabled } from '../../feature-flags';

/* eslint-disable no-console */
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import { Helper } from '../mixins/helpers.js';
import { Logger } from '../mixins/logger';
import { getAttributionParams } from '@/util/param-persistence';
import { buildGa4EcommerceItem } from '@/utils/ga4Items';
import CreditRequestService from '../services/credit-request.service.js';
import { BUTTON_LABEL } from '../shared/constants';
import { getTranscriptState } from './courses/courseTranscriptState';
import { Badge as UiBadge } from './ui';

export default defineComponent({
  name: 'MyCoursesComponent',
  components: { UiBadge },
  emits: [
    'openDetails',
    'closeModal',
    'addCourse',
    'pathwayCourses',
    'reloadDashboardOrPathway',
    'alreadyRequestedForCredit',
    'openCloseUnenrollModel'
  ],

  data() {
    return {
      displayInfo: false,
      dialog: false,
      isSelected: this.selected,
      originalSelection: this.courseSelected,
      on: '',
      addingLowerGradeCourseModal: false,
      displayLabel: false,
      enrollmentModeMsg: '',
      enrollmentModeLabel: '',
      ScreenWidth: 0,
      alert: false,
      addCoursesAlert: true,
      items: ['Pursue for Credit'],
      alertMsg: 'This course is not currently covered under your partnership. Fees may apply.',
      unenrollCourse: false,
      upgradeCourseDialog: false,
      collapsed: false,
      creditRequestRequestUUID: '',
      creditRequestTimestamp: '',
      creditRequestCourseOrg: '',
      creditRequestCourseNum: '',
      creditRequestCourseRun: '',
      creditRequestEnrollmentTimestamp: '',
      creditRequestCourseCompletionTimestamp: '',
      creditRequestFinalGrade: '',
      creditRequestUserUsername: '',
      creditRequestUserEmail: '',
      creditRequestUserFullName: '',
      creditRequestUserMailingAddress: '',
      creditRequestUserCountry: '',
      creditRequestSignature: '',
      shouldLoadCreditRequestForm: false,
      formattedCourseDesignations: '',
      showParentConsentModal: false
    };
  },

  mixins: [DataLayerMixin, Helper, Logger],

  props: {
    isLastCourse: {
      type: Boolean,
      default: false
    },
    setDisplayInformation: {
      type: String
    },
    LMS: {
      type: String
    },
    courseInfo: {
      type: Object
    },
    currentGrade: {
      type: String
    },
    eaCourseURL: {
      type: String
    },
    idVerificationDeadline: {
      type: String
    },
    finalGrade: {
      type: String,
      required: true
    },
    shouldShowViewCourse: {
      type: Boolean
    },
    grade: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    coursePrefix: {
      type: String,
      required: true
    },
    coursePrefixDisplayLabel: {
      type: String,
      required: true
    },
    creditConvertedDate: {
      type: String
    },
    courseStartDate: {
      type: String
    },
    courseEndDate: {
      type: String
    },
    courseCompletedDate: {
      type: String
    },
    enrollmentDate: {
      type: String
    },
    credits: {
      type: Number
    },
    buttonLabel: {
      type: String
    },
    buttonAction: {
      type: String
    },
    courseType: {
      type: String
    },
    from: {
      type: String
    },
    courseDescription: {
      type: String
    },
    courseUrl: {
      type: String
    },
    courseViewUrl: {
      type: String
    },
    selected: {
      type: Boolean
    },
    courseSelected: {
      type: Boolean
    },
    enrollmentStatus: {
      type: String
    },
    term: {
      type: String
    },
    unenroll: {
      type: Boolean
    },
    enrollmentMode: {
      type: String
    },
    courseSection: {
      type: String
    },
    courseSubSection: {
      type: String
    },
    benefitsEligible: {
      type: Boolean
    },
    benefitType: {
      type: String
    },
    deadlineCounter: {
      type: String
    },
    courseBrief: {
      type: String
    },
    courseOfferingId: {
      type: String
    },
    enrollmentId: {
      type: String
    },
    creditConverted: {
      type: String
    },
    progressPageURL: {
      type: String
    },
    creditConversionPrice: {
      type: Number
    },
    creditEligibilityPrice: {
      type: Number
    },
    // December 2024 Early Conversion Campaign (ULC-2637)
    campaignEligible: {
      type: Boolean,
      default: false
    },
    campaignCode: {
      type: String
    },
    creditConversionOriginalPrice: {
      type: Number
    },
    campaignDiscountAmount: {
      type: Number
    },
    isPathwayCourse: {
      type: Boolean
    },
    openEdxCourseId: {
      type: String
    },
    creditWindowOverride: {
      type: Boolean,
      default: false
    },
    transcriptedDate: {
      type: String
    },
    canvasEnrollmentId: {
      type: Number
    },
    canvasUserId: {
      type: Number,
      default: null
    },
    canvasCourseId: {
      type: Number
    },
    termStartDate: {
      type: String
    },
    termEndDate: {
      type: String
    },
    courseLength: String,
    partnerBenefitEligible: Boolean,
    coursePrerequisite: Object,
    isNonEnrollableCourse: Boolean,
    coursePrerequisiteLabel: {
      type: String
    },
    courseEffortPerHour: String,
    coursePacing: {
      type: String
    },
    courseDesignations: {
      type: String
    },
    courseIndex: Number,
    isCourseResetAllowed: Boolean,
    paymentMethod: String,
    enrollmentModeVerifiedDate: String,
    courseDropDeadline: Number,
    courseRegistrationDate: String,
    orientationStartDate: String,
    isCourseRefunded: Boolean,
    verifiedTransactionId: String,
    invisibleVoucher: {
      type: Object,
      default: null
    },
    completionLtiUrl: {
      type: String,
      default: null
    },
    multiEnrollmentType: {
      type: String,
      default: null
    }
  },

  computed: {
    getButtonLabel() {
      // Note: Backend now handles "Enroll and pay" -> "Enroll" conversion for benefit types 1,2,5
      if (this.buttonLabel === 'Enroll and pay' || this.buttonLabel === 'Enroll') {
        this.asuoDataLayerClick('MyCourses', '6', {
          section: this.courseSection
        });

        this.captureEcomDataLayer('view_cart');
      }

      // Backend now handles benefit type logic, return label as-is
      return this.buttonLabel;
    },

    enrollDeadlineText() {
      return this.idVerificationDeadline
        ? `Deadline: ${new Date(this.idVerificationDeadline).toLocaleString('utc', { dateStyle: 'short' })}, 11:59pm MST`
        : '';

      // return `${Math.round(this.compareCourseDateWithToday(this.idVerificationDeadline))} days left to enroll`;
    },

    buttonStyles() {
      const creditPendingOrHold = this.creditPendingOrHold;
      const buttonLabel = this.buttonLabel;
      // smAndDown: the CTAs share a full-width row under the dates on tablets
      const isMobile = this.$vuetify.display.smAndDown;

      // Define button colors based on label
      let backgroundColor = '';
      let color = '#191919';
      let border = 'none';
      let width = '';

      if (creditPendingOrHold) {
        backgroundColor = '#e0e0e0';
        color = '#9e9e9e';
      } else {
        // Yellow background for enrollment and completion buttons
        const yellowButtons = [
          'Conclude my course',
          'Conclude Course',
          'Conclude course',
          'Complete my course',
          'Complete course',
          'Add to Transcript',
          'Retry for Credit',
          'Enroll and pay',
          'Enroll',
          'Verify Identity'
        ];

        if (yellowButtons.includes(buttonLabel)) {
          backgroundColor = '#fec627';
        } else if (buttonLabel === 'Access Course') {
          backgroundColor = '#8c1d40';
          color = '#ffffff';
        } else if (buttonLabel === 'View Transcript') {
          backgroundColor = '#ffffff';
        }
      }

      // Border for specific buttons
      if (buttonLabel === 'View Transcript') {
        border = '1px solid #2a2a2a';
      }

      // Width adjustments
      if (isMobile) {
        width = '100%';
      } else if (buttonLabel === 'Access not available') {
        width = '175px';
      }

      return {
        'background-color': backgroundColor,
        color: color,
        border: border,
        width: width
      };
    },

    isIdVerificationDeadlineInFuture() {
      const date = new Date(this.idVerificationDeadline);

      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), '23', '59', '00') >= new Date();
    },
    shouldShowViewCourseForAudit() {
      return this.courseType === 'Audit' && this.courseCompletedDate;
    },

    shouldShowViewCourseResults() {
      return (
        this.buttonAction === 'View course results' &&
        this.enrollmentStatus.toLowerCase() !== 'inactive' &&
        !['verified', 'credit'].includes(this.courseInfo._enrollmentMode)
      );
    },
    shouldShowCourseResultButtonForStandardCourse() {
      return (
        this.enrollmentStatus.toLowerCase() == 'active' &&
        this.courseInfo._courseCreditEligible != 'Y' &&
        this.courseType === 'Standard' &&
        this.getDiff(new Date(), new Date(this.courseEndDate)) < 31 &&
        this.buttonAction.toLowerCase() !== 'access no longer available'
      );
    },
    // "Access no longer available" overflows a phone-width card, so shorten it.
    accessNoLongerLabel() {
      return this.$vuetify.display.xs ? 'Access not available' : 'Access no longer available';
    },
    shouldShowAccessNoLonger() {
      return (
        this.buttonAction === 'Access no longer available' ||
        (!this.courseResetAllowed() && (this.isCourseResetAllowed || '')) ||
        (this.enrollmentStatus || '').toLowerCase() === 'inactive' ||
        (!this.creditWindowOverride &&
          (this.courseInfo._courseCreditEligible || '').toLowerCase() === 'y' &&
          (this.creditConverted || '').toLowerCase() !== 'y' &&
          this.isDateDifferenceMoreThanOneYear(this.courseCompletedDate || '')) ||
        (!this.shouldShowViewCourseResults && !this.shouldShowCourseResultButtonForStandardCourse)
      );
    },
    creditPendingOrHold() {
      return [BUTTON_LABEL.CREDIT_PENDING, BUTTON_LABEL.CREDIT_ON_HOLD, BUTTON_LABEL.CREDIT_REJECTED].includes(
        this.buttonLabel
      );
    },

    // 'course-history' joined the list for ULC-3265: a learner whose partner
    // eligibility lapsed saw the caution on the dashboard and nowhere else.
    shouldShowWarningAsBenefitsNotEligible() {
      return (
        ['dashboard', 'add-courses', 'course-history'].includes(this.from) &&
        !this.isAudit &&
        !this.benefitsEligible &&
        this.partnerBenefitEligible
      );
    },

    // Nothing left to pay for: the course is over, or the credit is already on
    // the transcript. A "fees may apply" warning on either is just noise.
    showBenefitsWarningIcon() {
      return this.shouldShowWarningAsBenefitsNotEligible && !this.isPastCourse && !this.isTranscripted;
    },

    isTranscripted() {
      return this.courseSection === 'Transcripted Courses';
    },

    // Add Courses opens the banner by default; the other surfaces start collapsed
    // behind the triangle. Keeping both flags preserves that split now that one
    // block of markup serves every surface.
    benefitsAlertOpen: {
      get() {
        return this.from === 'add-courses' ? this.addCoursesAlert : this.alert;
      },
      set(value) {
        if (this.from === 'add-courses') this.addCoursesAlert = value;
        else this.alert = value;
      }
    },

    isCourseTranscripted() {
      return this.creditConverted === 'Y';
    },

    // --- Transcript card states (ACC-355) — logic lives in courseTranscriptState.js ---
    transcriptState() {
      return getTranscriptState({
        buttonLabel: this.buttonLabel,
        buttonAction: this.buttonAction,
        courseSection: this.courseSection,
        courseCompletedDate: this.courseCompletedDate,
        transcriptedDate: this.transcriptedDate,
        creditConverted: this.creditConverted,
        creditEligible: this.courseInfo?._courseCreditEligible,
        enrollmentStatus: this.enrollmentStatus,
        creditWindowOverride: this.creditWindowOverride
      });
    },
    transcriptTag() {
      return this.transcriptState.tag;
    },
    transcriptDaysLeft() {
      return this.transcriptState.daysLeft;
    },
    transcriptDaysLeftText() {
      return this.transcriptState.daysLeftText;
    },

    isAudit() {
      return (this.courseType || '').toLowerCase() == 'audit';
    },

    // Suppresses the enrollment CTA and the Options menu: the content is gone,
    // so those land on a Canvas access-denied page. Past cards still get their
    // own block below ("View course results" / "Access no longer available").
    isPastCourse() {
      return this.courseSection === 'Past Courses';
    },

    // My Courses lists live courses, so they get the same Options menu the
    // dashboard gives them. Past Courses stay action-free.
    isCourseHistoryActionable() {
      return this.from === 'course-history' && !this.isPastCourse;
    },

    // Every non-Past My Courses card gets the dashboard's CTA. An allowlist here
    // silently dropped labels the backend can return (Verify Identity, Enroll,
    // Conclude Course), leaving those cards with no button at all.
    // Both menu entries are conditional, so the button could open an empty menu: a
    // preregistration has no unenroll, and an unmapped offering no description.
    hasOptionsMenuItems() {
      return !!this.courseDescription || !!this.unenroll;
    },

    isFromCourseHistoryAndAddToTranscript() {
      return (
        ((this.from === 'dashboard' || this.from === 'pathways') && !this.isPastCourse) ||
        this.isCourseHistoryActionable
      );
    },

    warningMessageBasedOnCourseType() {
      return this.isSelfPaced() && this.$conn.getPartnerName() === 'starbucks'
        ? 'This On-Demand course is not covered under your partnership. Fees will apply.'
        : this.alertMsg;
    },

    // Phone-width span for a details item. The row is a fixed 3-up grid, so a
    // card with only two indicators (e.g. TRANSCRIPT BY + CREDITS) left a third
    // of the row empty and wrapped the long label. Share the full width instead;
    // sm+ keeps the 3-up grid.
    labelSectionCols() {
      const count = this.label_sections.length;
      if (count <= 1) return 12;
      if (count === 2) return 6;
      return 4;
    },

    // Only the two-up phone layout splits the row, so send the second item to
    // the far edge; every other case keeps the left-aligned grid.
    isTwoUpDetails() {
      return this.$vuetify.display.xs && this.label_sections.length === 2;
    },

    label_sections() {
      let labelsArr = [];

      if (this.buttonLabel === 'Add to Transcript' && this.courseCompletedDate) {
        let datePlusOneYear = new Date(this.courseCompletedDate); //eslint-disable-line

        datePlusOneYear.setFullYear(datePlusOneYear.getFullYear() + 1);

        // ULC-3378: under an approved override a passed deadline is not a deadline
        if (!(this.creditWindowOverride && datePlusOneYear.getTime() < Date.now())) {
          labelsArr.push({
            key: 'TRANSCRIPT BY',
            value: this.getDateString(datePlusOneYear)
          });
        }
      } else if (this.creditConvertedDate) {
        if (this.buttonAction === 'View Transcript') {
          labelsArr.push({
            key: 'Transcripted',
            value: this.safeDateFormat(this.transcriptedDate)
          });
        } else {
          // OS-5071 formatted the creditConvertedDate
          labelsArr.push({
            key: 'Fee Paid On',
            value: [
              new Date(this.creditConvertedDate).getMonth() + 1,
              new Date(this.creditConvertedDate).getDate(),
              new Date(this.creditConvertedDate).getFullYear()
            ].join('/')
          });
        }
      } else {
        if (this.courseSection !== 'Courses Remaining' && this.courseSection !== 'Courses Completed') {
          if (this.courseSection === 'Past Courses') {
            if (this.courseType === 'Continuous') {
              labelsArr.push({
                key: 'start',
                value: this.safeDateFormat(this.enrollmentDate)
              });
            } else {
              labelsArr.push({
                key: 'start',
                value: this.safeDateFormat(this.courseStartDate)
              });
            }
          } else {
            labelsArr.push({
              key: 'start',
              value: this.getCourseStartDate
            });
          }
        }
      }
      if (
        this.from !== 'pathways' &&
        this.courseSection !== 'Add to Transcript' &&
        this.courseSection !== 'Courses Remaining' &&
        this.courseSection !== 'Courses Completed' &&
        this.courseSection !== 'Transcripted Courses'
      ) {
        if (this.courseSection === 'Past Courses') {
          labelsArr.push({
            key: 'end',
            value: this.safeDateFormat(this.courseEndDate)
          });
        } else {
          labelsArr.push({
            key: 'end',
            value: this.getCourseEndDate
          });
        }
      }

      if (this.credits >= 0) {
        labelsArr.push({
          key: 'credits',
          value: this.credits + ' Credits'
        });
      }

      if (
        this.courseSection === 'Add to Transcript' ||
        this.courseSection === 'Courses Completed' ||
        this.from === 'pathways' ||
        this.courseSection === 'Transcripted Courses'
      ) {
        if (this.finalGrade && this.grade && this.courseCompletedDate) {
          labelsArr.push({
            key: 'grade',
            value: this.getGrade()
          });
        }
      }

      if (this.courseSubSection === 'Open Now' && this.from === 'pathways') {
        labelsArr.push({
          key: 'Length',
          value: this.getCourseLength()
        });
      }

      if (this.from === 'add-courses') {
        // let diff =
        //   new Date(this.courseEndDate).getTime() -
        //   new Date(this.courseStartDate).getTime();
      }
      return labelsArr;
    },

    getCourseStartDate() {
      if (this.isContinuousOrAuditCourse()) {
        // ULC-3288: mirrors getCourseEndDate — only the not-yet-enrolled catalog
        // view falls back to 'Today'; every enrolled view resolves the real date.
        if (this.from === 'add-courses') {
          if (this.courseStartDate && this.compareCourseDateWithToday(this.courseStartDate) > 0) {
            return this.safeDateFormat(this.courseStartDate);
          }
          return 'Today';
        } else {
          return this.getContinuousCourseStartDate();
        }
      } else {
        // For standard courses, use safeDateFormat to handle invalid dates
        return this.safeDateFormat(this.courseStartDate);
      }
    },

    getCourseEndDate() {
      if (this.isContinuousOrAuditCourse()) {
        if (this.from === 'add-courses') {
          return this.getFuture365(this.today());
        } else {
          return this.getContinuousCourseEndDate();
        }
      } else {
        // For standard courses, use safeDateFormat to handle invalid/empty dates
        return this.safeDateFormat(this.courseEndDate);
      }
    },

    check_circle() {
      return this.originalSelection ? 'mdi-check-circle' : 'mdi-check-circle';
    },

    courseStartingInFuture() {
      if ((this.courseType || '') === 'Continuous') {
        return this.isDateInFuture(this.courseRegistrationDate || '');
      }
      return this.isDateInFuture(this.courseStartDate || '');
    },

    unavailableClass() {
      return this.buttonLabel === 'Access Course' && !this.isOrientationStarted && this.courseStartingInFuture
        ? 'unavailable'
        : '';
    },

    isOrientationStarted() {
      return this.isDateInPast(
        new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Phoenix' })),
        new Date(this.orientationStartDate)
      );
    },
    eaPathwaysGpaAlert() {
      // This field is to trigger GPA alert modal between EA and ULC | If true Show EA and Pathways GPA Alert Modal else Show ULC Modal
      const learnerData = this.getLearnerData;
      const _partnerURLSubDomain = learnerData?._partnerURLSubDomain;

      const eaPathwaysPartners = ['starbucks', 'uber', 'google'];
      return (
        eaPathwaysPartners.includes(_partnerURLSubDomain) ||
        (_partnerURLSubDomain === 'welcome' && !this.ulcPartnerFlag)
      );
    },
    ulcPartnerFlag() {
      return Helper.methods.isUlcPartner();
    },
    isAccelerateDashboard() {
      const learnerData = this.getLearnerData;
      return this.from === 'dashboard' && Helper.methods.isAcceleratePartner(learnerData?._partnerURLSubDomain);
    },
    ...mapState(useUserStore, ['getLearnerData'])
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    labelSectionAlign(index) {
      return this.isTwoUpDetails && index === 1 ? 'right' : 'left';
    },

    trackCtaButtonClick() {
      const isEnroll = this.buttonLabel === 'Enroll and pay' || this.buttonLabel === 'Enroll';
      this.asuoDataLayerClick('MyCourses', '0', '', {
        event: isEnroll ? 'select' : 'link',
        type: isEnroll ? 'dropdown' : 'internal link',
        region: 'main content',
        section: this.title,
        text: this.buttonLabel
      });
    },
    captureEcomDataLayer(event) {
      // Clear previous ecommerce object
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
      }

      const { campaign, partner } = getAttributionParams();

      //Ecom data layer
      const ecom = {
        event: event,
        campaign,
        partner,
        ecommerce: {
          currency: 'USD',
          value: 25.0,
          items: [
            // Interest track and session name aren't in the v1 enrollments payload.
            buildGa4EcommerceItem({
              canvasCourseId: this.canvasCourseId,
              offeringId: this.courseOfferingId,
              courseName: this.title,
              coursePrefix: this.coursePrefix,
              startDate: this.courseStartDate,
              courseType: this.courseType,
              price: 25.0
            })
          ]
        }
      };

      this.asuoDataLayerClick('ecommerceTags', '0', ecom);
    },
    handleResize() {
      this.formatTextWithLineBreaks();
    },

    formatTextWithLineBreaks() {
      if (this.courseDesignations) {
        let formattedValue = this.courseDesignations.replace(/\r\n/g, ' | ');

        let elements = formattedValue.split(' | ');

        let groupedValues = {};

        elements.forEach((element) => {
          let [beforeHyphen, afterHyphen] = element.split(' - ');

          if (beforeHyphen) {
            if (!groupedValues[beforeHyphen]) {
              groupedValues[beforeHyphen] = [];
            }

            groupedValues[beforeHyphen].push(afterHyphen ? beforeHyphen + ' - ' + afterHyphen : beforeHyphen);
          }
        });

        let formattedText = '';

        for (const key in groupedValues) {
          if (Object.prototype.hasOwnProperty.call(groupedValues, key)) {
            formattedText += groupedValues[key].join(' | ') + '\n';
          }
        }

        this.formattedCourseDesignations = formattedText.replace(/\n/g, '<br>');
      } else {
        this.formattedCourseDesignations = '--';
      }
    },

    getTextWidth(text) {
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      context.font = getComputedStyle(document.body).fontSize + ' Arial';
      return context.measureText(text).width;
    },

    getContinuousCourseEndDate() {
      if (this.enrollmentMode === 'honor') {
        return this.getFuture365(new Date());
      } else if (this.enrollmentMode === 'verified') {
        // Check if enrollmentModeVerifiedDate is valid before using it
        if (this.enrollmentModeVerifiedDate) {
          const verifiedDate = new Date(this.enrollmentModeVerifiedDate);
          if (!isNaN(verifiedDate.getTime())) {
            return this.getFuture365(verifiedDate);
          }
        }
        // Fallback to current date + 365 days if date is invalid
        return this.getFuture365(new Date());
      } else {
        // Audit type courses: courseRegistration date +1year will be the end date
        if (this.courseRegistrationDate) {
          const regDate = new Date(this.courseRegistrationDate);
          if (!isNaN(regDate.getTime())) {
            return this.getFuture365(regDate);
          }
        }
        // Fallback to current date + 365 days if date is invalid
        return this.getFuture365(new Date());
      }
    },
    getContinuousCourseStartDate() {
      if (this.enrollmentMode === 'honor') {
        return 'Today';
      } else if (this.enrollmentMode === 'verified') {
        // Check if enrollmentModeVerifiedDate is valid before using it
        if (this.enrollmentModeVerifiedDate) {
          const verifiedDate = new Date(this.enrollmentModeVerifiedDate);
          if (!isNaN(verifiedDate.getTime())) {
            return this.getDateString(verifiedDate);
          }
        }
        // Fallback to 'Today' if date is invalid
        return 'Today';
      } else {
        // Audit type courses: courseRegistration date will be the start date
        if (this.courseRegistrationDate) {
          const regDate = new Date(this.courseRegistrationDate);
          if (!isNaN(regDate.getTime())) {
            return this.getDateString(regDate);
          }
        }
        // Fallback to 'Today' if date is invalid
        return 'Today';
      }
    },
    openDetails() {
      this.$emit('openDetails', 'openDetails', true);
    },
    closeModal() {
      this.$emit('closeModal', 'closeDetails', true);
    },
    openCloseUnenrollModel() {
      this.unenrollCourse = !this.unenrollCourse;
    },
    openModal() {
      const data = {
        Id: this.enrollmentId,
        Is_Course_Reset_Requested__c: true,
        hed__Course_Offering__c: this.courseInfo._openEdxCourseId,
        username: this.getLearnerData?._asuRite
      };
      this.$conn.resetCourse(data);
      this.dialog = true;
    },
    courseResetAllowed() {
      if (this.isCourseResetAllowed) {
        if (!this.courseEndDate || (this.courseEndDate && new Date(this.courseEndDate) > new Date())) {
          return true;
        } else if (this.courseEndDate && new Date(this.courseEndDate) < new Date()) {
          return false;
        }
      }
    },
    confirmResetCourse() {
      // Emit event to parent instead of mutating prop
      this.$emit('courseResetRequested', this.courseInfo);
      this.dialog = false;
    },
    updateLastLoginCourse() {
      const lastLoginInCourse = new Date().toISOString().slice(0, 19).replace('T', ' ');

      try {
        this.$conn.patchEnrollmentsData([
          {
            enrollmentId: this.enrollmentId,
            lastLoginInCourse
          }
        ]);
      } catch (error) {
        this.logError('Patch failed during accessing course', error);
      }
    },
    addCourseAction(coursePrefix, courseStartDate, courseOfferingId) {
      if (!this.isNonEnrollableCourse && this.addCourseButton()) {
        this.addCourse(coursePrefix, courseStartDate, courseOfferingId);
      }
    },
    addCourseButton() {
      return !this.preRequiredButton();
    },

    preRequiredButton() {
      return (
        this.coursePrerequisite &&
        (!this.coursePrerequisite.courseCompletedDate || this.coursePrerequisite.courseCompletedDate.length === 0) &&
        (this.coursePrerequisite.creditEligible || '').toLowerCase() !== 'y' &&
        this.coursePrerequisite.courseName
      );
    },

    compareCourseDateWithToday(courseDate) {
      // Negation of calculateAge because it substracts the passed date with today's date
      // Negative Float === Past
      // Positive Float === Future
      return -parseFloat(this.calculateAge(courseDate));
    },

    getFuture365(courseDate) {
      let date = new Date(courseDate);
      date.setDate(date.getDate() + 365);
      return date.toLocaleDateString('en-us');
    },

    isContinuousOrAuditCourse() {
      return this.isOrientation() || this.isSelfPaced();
    },

    viewFullCourseDetails(url) {
      try {
        // Format https://courses.ea.asu.edu/college-algebra-mat-117/

        // Check if the current host is a ULC URL
        const isULCUrl = Helper.methods.isUlcPartner();

        // Parse the input URL
        const parsedUrl = new URL(url);
        const hostParts = parsedUrl.hostname.split('.');

        // hostParts should be 4
        if (hostParts.length === 4) hostParts[1] = !isULCUrl ? 'ea' : 'ulc';

        parsedUrl.hostname = hostParts.join('.');

        // Open the updated URL in a new tab
        window.open(parsedUrl.toString(), '_blank');
      } catch (error) {
        this.logError('Error processing URL', error);
      }
    },
    removeBorder() {
      Array.from(document.getElementsByClassName('v-alert')).forEach((e) => (e.style.border = 'none'));

      if (this.from === 'add-courses' && this.courseIndex === 0) this.alert = !this.alert;
    },
    initEligibilityTrack() {
      if (!this.isAudit) {
        if (this.enrollmentMode === 'honor' && new Date(this.idVerificationDeadline) > new Date()) {
          this.enrollmentModeLabel = 'Audit';

          this.enrollmentModeMsg =
            'You are currently auditing this course. To complete your enrollment, click the Upgrade button to upgrade to the credit eligible track.';
        } else if (this.enrollmentMode === 'honor' && new Date(this.idVerificationDeadline) < new Date()) {
          this.enrollmentModeLabel = 'Audit';

          this.enrollmentModeMsg =
            'You are currently auditing this course and the deadline to upgrade has passed. You can participate in the course but will not be eligible for academic credit.';
        } else if (this.enrollmentMode === 'honor' && this.courseType === 'Continuous' && !this.isAudit) {
          this.enrollmentModeLabel = 'Audit';

          this.enrollmentModeMsg =
            'You are currently auditing this course. To complete your enrollment, click the Upgrade button to upgrade to the credit eligible track.';
        }
      }
      // if (this.enrollmentMode === 'honor' || this.enrollmentMode === 'audit') {
      //   this.enrollmentModeLabel = 'Audit';
      //   this.enrollmentModeMsg =
      //     this.buttonLabel === 'Pursue credit'
      //       ? 'You are on the Audit Track for this course. You can participate in the course but will not be eligible to receive academic credit at the end. <br><br><b>Click the "Pursue credit" button if you would like to upgrade to the Credit Eligible Track.<b>'
      //       : 'You are on the Audit Track for this course and the deadline to upgrade to the Credit Eligible Track has passed.<br><br> You can participate in the course but will not be eligible to receive academic credit at the end. ';
      // } else if (this.enrollmentMode === 'verified') {
      //   this.enrollmentModeLabel = 'Credit Eligible';
      //   this.enrollmentModeMsg =
      //     'You are on the Credit Eligible Track for this course. You will be eligible to receive credit once you have met all course requirements. ';
      // } else if (this.enrollmentMode === 'credit') {
      //   this.enrollmentModeLabel = 'Credit Received';
      //   this.enrollmentModeMsg = 'You have already received credit for this course. Congratulations!';
      // }
      this.displayLabel = true;
    },
    termHas(letter) {
      return (this.term || '').indexOf(letter) >= 0;
    },
    addCourse(coursePrefix, courseStartDate, courseOfferingId) {
      if (this.originalSelection || this.isCourseTranscripted) return;

      this.$emit('addCourse', {
        coursePrefix,
        courseStartDate,
        add: !this.isSelected,
        courseOfferingId
      });
    },

    pathwayCourses(coursePrefix, courseStartDate) {
      courseStartDate = courseStartDate.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/, function (match, y, m, d) {
        return m + '/' + d + '/' + y;
      });

      this.$emit('pathwayCourses', {
        coursePrefix,
        courseStartDate,
        add: !this.isSelected
      });
    },

    displayInformation() {
      this.captureEcomDataLayer('view_item');

      this.displayInfo = !this.displayInfo;
    },

    continueToAddTranscript() {
      this.addingLowerGradeCourseModal = false;
      if (this.shouldDisplayParentConsent()) {
        this.goToParentConsentPage(); // Go to the parent consent page if the learner is minor
        return;
      }

      if ((this.enrollmentStatus || '').toLowerCase() === 'inactive') return;

      // The following functionality is deprecated, verify identity is hosted in app now

      // if (this.courseUrl && this.buttonLabel === 'Verify student')
      //   return window.open(this.courseUrl.split('edu/')[0] + 'edu/verify_student/reverify', '_blank');

      // window.open(this.courseUrl, '_blank');

      return this.goToCourseCheckout();
    },

    goToCourseCheckout() {
      // this.captureEcomDataLayer('purchase');

      // Use Pinia checkout store for complex data
      const checkoutStore = useCheckoutStore();

      // Set all checkout data in the store
      const _checkoutPayload1 = {
        title: this.title,
        coursePrefix: this.coursePrefix,
        coursePrefixDisplayLabel: this.coursePrefixDisplayLabel,
        courseStartDate: this.courseStartDate,
        courseEndDate: this.courseEndDate,
        courseType: this.courseType,
        benefitsEligible: this.benefitsEligible,
        benefitType: this.benefitType,
        courseInfo: {
          ...this.courseInfo,
          // December 2024 Early Conversion Campaign (ULC-2637)
          // Add campaign fields to courseInfo for checkout
          // Use props if passed, fallback to courseInfo underscore-prefixed properties
          campaignEligible: this.campaignEligible || this.courseInfo?._campaignEligible || false,
          campaignCode: this.campaignCode || this.courseInfo?._campaignCode || '',
          creditConversionOriginalPrice:
            this.creditConversionOriginalPrice || this.courseInfo?._creditConversionOriginalPrice || 0,
          campaignDiscountAmount: this.campaignDiscountAmount || this.courseInfo?._campaignDiscountAmount || 0,
          invisibleVoucher: this.invisibleVoucher
        },
        enrollmentId: this.enrollmentId,
        multiEnrollmentType: this.multiEnrollmentType,
        buttonLabel: this.buttonLabel,
        finalGrade: this.finalGrade,
        currentGrade: this.currentGrade,
        grade: this.grade,
        courseOfferingId: this.courseOfferingId,
        buttonAction: this.buttonAction,
        courseCompletedDate: this.courseCompletedDate,
        enrollmentDate: this.enrollmentDate,
        creditConversionPrice: this.creditConversionPrice,
        creditEligibilityPrice: this.creditEligibilityPrice,
        lms: this.LMS,
        canvasEnrollmentId: this.canvasEnrollmentId,
        canvasUserId: this.canvasUserId,
        canvasCourseId: this.canvasCourseId,
        credits: this.credits,
        from: this.from || 'dashboard'
      };
      checkoutStore.setCheckoutData(_checkoutPayload1);

      // Navigate to checkout with clean URL
      return this.$router.push({ name: 'courseCheckout' });
    },
    shouldDisplayParentConsent() {
      return (
        ((this.calculateAge(this.getLearnerData?._birthDate) / 365.25 < 18 &&
          ['Upgrade', 'UpgradeModal', 'Enroll and pay'].indexOf(this.buttonAction) >= 0 &&
          (this.benefitType == 3 || this.benefitType == 4)) ||
          (this.calculateAge(this.getLearnerData?._birthDate) / 365.25 < 18 &&
            this.buttonAction === 'Add to Transcript' &&
            (this.benefitType == 2 || this.benefitType == 4))) &&
        !this.isAudit
      );
    },

    callCreditRequestChildComponent(response) {
      if (!response) return;

      this.creditRequestRequestUUID = response['request_uuid'];
      this.creditRequestCourseOrg = response['course_org'];
      this.creditRequestCourseRun = response['course_run'];
      this.creditRequestCourseNum = response['course_num'];
      this.creditRequestTimestamp = response['timestamp'];
      this.creditRequestUserUsername = response['user_username'];
      this.creditRequestUserEmail = response['user_email'];
      this.creditRequestUserFullName = response['user_full_name'];
      this.creditRequestUserMailingAddress = response['user_mailing_address'];
      this.creditRequestUserCountry = response['user_country'];
      this.creditRequestSignature = response['signature'];
      this.creditRequestEnrollmentTimestamp = response['enrollment_timestamp'];
      this.creditRequestCourseCompletionTimestamp = response['course_completion_timestamp'];
      this.creditRequestFinalGrade = response['final_grade'];

      this.shouldLoadCreditRequestForm = true;
    },

    async ctaCourseEnrollmentAction() {
      // Support both "Conclude" (new) and "Complete" (legacy) for backwards compatibility
      if (
        this.buttonAction === 'Conclude my course' ||
        this.buttonAction === 'Conclude Course' ||
        this.buttonAction === 'Conclude course' ||
        this.buttonLabel === 'Conclude my course' ||
        this.buttonLabel === 'Conclude Course' ||
        this.buttonLabel === 'Conclude course' ||
        this.buttonAction === 'Complete my course' ||
        this.buttonAction === 'Complete course' ||
        this.buttonLabel === 'Complete my course' ||
        this.buttonLabel === 'Complete course'
      ) {
        if (this.completionLtiUrl) {
          this.navigateToURL(this.completionLtiUrl);
        } else {
          // Fallback to course progress page if completion URL not available
          this.navigateToURL(this.progressPageURL || this.courseUrl);
        }
        return;
      }

      if (this.getButtonLabel === 'Enroll') {
        await this.$conn.patchEnrollmentsData([
          {
            enrollmentId: this.enrollmentId,
            enrollmentMode: 'verified'
          }
        ]);

        this.$emit('reloadDashboardOrPathway', { enrollmentId: this.enrollmentId, enrollmentMode: 'verified' });
      } else if (this.buttonAction === 'Add to Transcript' && this.finalGrade === 'C') {
        {
          // Show low grade modal
          this.addingLowerGradeCourseModal = true;
          return;
        }
      } else if (this.shouldDisplayParentConsent()) {
        this.goToParentConsentPage(); // Go to the parent consent page if the learner is minor
      } else if (this.buttonAction === 'Retry for Credit') {
        try {
          let enrollmentRes = await this.$conn.getEnrollmentById(this.enrollmentId);

          //Validation before clicking to check whether already requested for credit
          if (
            enrollmentRes &&
            (
              (((enrollmentRes.data || {}).enrollments[0] || {}).courseInfo || {}).creditConversionStatus || ''
            ).toLowerCase() !== 'retry'
          ) {
            this.$emit('alreadyRequestedForCredit', true);
          } else {
            // Check feature flag for new credit request flow
            const useNewCreditFlow = isFeatureEnabled('NEW_CREDIT_FLOW');

            let creditRequestResponse;

            if (useNewCreditFlow) {
              // New flow: Use AddToTranscript component with v2 API
              const userStore = useUserStore();
              const asurite = userStore.apis.learnerData._asuRite;
              const enrollmentId = this.enrollmentId;

              return this.$router.push({
                path: '/add-to-transcript',
                query: {
                  asurite: asurite,
                  enrollmentId: enrollmentId
                }
              });
            } else {
              // Old flow: Use existing CreditRequestService
              creditRequestResponse = await CreditRequestService.sendCreditRequest({
                _finalGrade: this.finalGrade,
                _grade: isNaN(this.grade) ? this.grade : this.grade.toFixed(2),
                _courseCompletedDate: this.courseCompletedDate,
                _enrollmentDate: this.enrollmentDate,
                _enrollmentId: this.enrollmentId,
                _courseInfo: {
                  _openEdxCourseId: this.courseInfo._openEdxCourseId,
                  _courseOrg: this.courseInfo._courseOrg,
                  _courseRun: this.courseInfo._courseRun,
                  _courseNum: this.courseInfo._courseNum,
                  _lms: this.courseInfo._lms
                }
              });

              // TODO: Need a modal error to show if we get a 400 status or empty repose back from above postCreditRequest,
              // show a message - "Something went wrong, please contact support."
              this.callCreditRequestChildComponent(creditRequestResponse);
            }
          }
        } catch (error) {
          this.logError('Failed to retry credit request', error.stack);
        }
      } else {
        this.openCourse(this.buttonLabel === 'Access Course' && this.buttonAction !== 'Enroll and pay' ? 'view' : '');
      }
    },

    openCourse(view) {
      if (view && this.courseStartingInFuture && !this.isOrientationStarted) return;

      if ((this.enrollmentStatus || '').toLowerCase() === 'inactive') return;

      if (this.courseUrl && this.buttonAction === 'Verify Identity')
        return this.$router.push({ name: 'id-verification' });

      if (!view && ['Add to Transcript', 'UpgradeModal', 'Upgrade', 'Enroll and pay'].indexOf(this.buttonAction) > -1)
        return this.goToCourseCheckout();

      if (this.buttonAction === BUTTON_LABEL.NEEDS_ASURITE_ACTIVATION) {
        this.logInfo('Needs ASURITE activation, redirecting to asurite login');

        this.$auth.login('asurite', {
          state: btoa(
            JSON.stringify({
              redirect_to: {
                name: 'courses-history'
              },
              learnerId: this.getLearnerData?._learnerId
            })
          )
        });

        return;
      }

      //to update last login course date and time
      this.updateLastLoginCourse();

      //open course
      const urlToOpen = !!view && this.courseViewUrl ? this.courseViewUrl : this.courseUrl;

      window.open(urlToOpen);
    },

    isDateInFuture(date) {
      return new Date() < new Date(date);
    },

    isDateInPast(date1, date2) {
      return date1.getTime() > date2.getTime();
    },

    isDateBetween(dateToCompare, startDate, endDate) {
      return dateToCompare.getTime() > startDate.getTime() && dateToCompare.getTime() < endDate.getTime();
    },

    isDateDifferenceMoreThanOneYear(startDate, endDate = new Date()) {
      const oneYearInMillis = 365 * 24 * 60 * 60 * 1000;
      return new Date(startDate).getTime() + oneYearInMillis < endDate.getTime();
    },

    getGrade() {
      let calc = '';

      if (this.grade && !isNaN(this.grade)) calc = parseFloat(this.grade) * 100;

      return Math.round(calc) + ' / ' + this.finalGrade;
    },

    getDateString(date) {
      return [date.getMonth() + 1, date.getDate(), date.getFullYear()].join('/');
    },
    safeDateFormat(dateValue, fallback = 'TBD') {
      // Handle null, undefined, or empty string values
      if (!dateValue || dateValue === '' || dateValue === 'null' || dateValue === 'undefined') {
        return fallback;
      }

      // Try to create a valid date object
      const date = new Date(dateValue);

      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return fallback;
      }

      // Use existing getDateString method for formatting
      return this.getDateString(date);
    },

    checkForGetCredit() {
      if (this.buttonAction === 'Add to Transcript' && this.enrollment._courseCompletedDate && this.finalGrade == 'C') {
        this.addingLowerGradeCourseModal = true;

        let diff = 365 - Math.abs(this.getDiff(Date.now(), this.enrollment._courseCompletedDate));
        this.enrollment.creditCounter = {};
        this.enrollment.creditCounter.count = diff >= 0 && diff <= 365 ? diff : 0;
        this.enrollment.creditCounter.ordinal = diff > 1 ? 'days' : 'day';
        this.enrollment.creditCounter.message = `You have ${this.enrollment.creditCounter.count} ${this.enrollment.creditCounter.ordinal} to pay for your credit for the course. Click the Get credit button to receive your academic credit.`;

        return true;
      }
      return false;
    },

    hasStarted() {
      return this.getDiff(this.courseStartDate, Date.now()) <= 0 ? true : false;
    },

    getDiff(startDate, enrolledDate) {
      return parseInt((new Date(startDate) - new Date(enrolledDate)) / (1000 * 60 * 60 * 24));
    },

    getCourseLength() {
      // /4[A-C]$/g regex is for summer courses with terms C are also 8 weeks

      if (this.term === 'On-demand') {
        return 'On-demand';
      } else if (this.term === 'Self Paced') {
        return 'Self Paced';
      } else if (this.termHas('A') || this.termHas('B')) {
        return '8 weeks';
      } else if ((this.term || '').match(/4[A-C]$/g) != null) {
        return '8 weeks';
      } else if (this.termHas('C')) {
        return '16 weeks';
      } else {
        return '';
      }
    },

    isOrientation() {
      return ['audit'].indexOf((this.courseType || '').toLowerCase()) > -1;
    },

    isSelfPaced() {
      return ['continuous'].indexOf((this.courseType || '').toLowerCase()) > -1;
    },

    isCourseDateInFuture() {
      return new Date(this.courseStartDate) > new Date();
    },

    doUnenroll() {
      this.$emit('openCloseUnenrollModel', {
        courseUnenrollInfo: {
          courseInfo: Object.assign({}, this.courseInfo),
          paymentMethod: this.paymentMethod,
          enrollmentModeVerifiedDate: this.enrollmentModeVerifiedDate,
          enrollmentId: this.enrollmentId,
          courseDropDeadline: this.courseDropDeadline,
          enrollmentMode: (this.courseInfo || {})._enrollmentMode || '',
          buttonAction: this.buttonAction,
          isCourseRefunded: this.isCourseRefunded,
          verifiedTransactionId: this.verifiedTransactionId
        }
      });
    },
    goToParentConsentPage() {
      // Use Pinia checkout store for complex data
      const checkoutStore = useCheckoutStore();

      const transactionFee =
        ['Upgrade', 'UpgradeModal', 'Enroll and pay'].indexOf(this.buttonAction) >= 0
          ? 'enrollment fee'
          : 'credit conversion fee';

      const checkoutData = {
        title: this.title,
        coursePrefix: this.coursePrefix,
        coursePrefixDisplayLabel: this.coursePrefixDisplayLabel,
        courseStartDate: this.courseStartDate,
        courseEndDate: this.courseEndDate,
        courseType: this.courseType,
        benefitsEligible: this.benefitsEligible,
        benefitType: this.benefitType,
        courseInfo: {
          ...this.courseInfo,
          // December 2024 Early Conversion Campaign (ULC-2637)
          // Add campaign fields to courseInfo for checkout (same as goToCourseCheckout)
          // Use props if passed, fallback to courseInfo underscore-prefixed properties
          campaignEligible: this.campaignEligible || this.courseInfo?._campaignEligible || false,
          campaignCode: this.campaignCode || this.courseInfo?._campaignCode || '',
          creditConversionOriginalPrice:
            this.creditConversionOriginalPrice || this.courseInfo?._creditConversionOriginalPrice || 0,
          campaignDiscountAmount: this.campaignDiscountAmount || this.courseInfo?._campaignDiscountAmount || 0
        },
        enrollmentId: this.enrollmentId,
        multiEnrollmentType: this.multiEnrollmentType,
        enrollmentStatus: this.enrollmentStatus,
        courseUrl: this.courseUrl,
        buttonLabel: this.buttonLabel,
        finalGrade: this.finalGrade,
        currentGrade: this.currentGrade,
        grade: this.grade,
        courseOfferingId: this.courseOfferingId,
        buttonAction: this.buttonAction,
        courseCompletedDate: this.courseCompletedDate,
        enrollmentDate: this.enrollmentDate,
        creditConversionPrice: this.creditConversionPrice,
        creditEligibilityPrice: this.creditEligibilityPrice,
        lms: this.LMS,
        canvasEnrollmentId: this.canvasEnrollmentId,
        canvasUserId: this.canvasUserId,
        canvasCourseId: this.canvasCourseId,
        credits: this.credits,
        transactionFee: transactionFee,
        from: 'dashboard'
      };

      checkoutStore.setCheckoutData(checkoutData);

      // Set parental consent specific data
      checkoutStore.setParentalConsentData({
        enrollmentId: this.enrollmentId,
        courseName: `${this.coursePrefix} ${this.title}`,
        courseOfferingId: this.courseOfferingId,
        from: 'dashboard'
      });

      // Show modal instead of navigating to separate page
      this.showParentConsentModal = true;
    },

    async handleParentConsent(parentData) {
      try {
        const parentConsentData = {
          enrollmentId: this.enrollmentId,
          timeStamp: new Date().toISOString(),
          transactionFee:
            ['Upgrade', 'UpgradeModal', 'Enroll and pay'].indexOf(this.buttonAction) >= 0
              ? 'enrollment fee'
              : 'credit conversion fee',
          asurite: this.getLearnerData?._asuRite,
          parentName: `${parentData.firstName} ${parentData.lastName}`,
          firstName: parentData.firstName,
          lastName: parentData.lastName
        };

        // Save parental consent
        await this.$conn.patchEnrollmentsData([
          {
            enrollmentId: this.enrollmentId,
            transactionConsent: parentConsentData
          }
        ]);

        // Close modal
        this.showParentConsentModal = false;

        // Get checkout store data (already set from goToParentConsentPage)
        const checkoutStore = useCheckoutStore();

        // Update the 'from' field to indicate parental consent flow
        checkoutStore.from = 'parental-consent';

        // Navigate to checkout with clean URL (data is in store)
        this.$router.push({ name: 'courseCheckout' });
      } catch (error) {
        this.logError('handleParentConsent patchEnrollmentsData', error);
      }
    },
    handleParentConsentCancel() {
      this.showParentConsentModal = false;
    }
  },

  mounted() {
    this.removeBorder();

    this.formatTextWithLineBreaks();

    window.addEventListener('resize', this.handleResize);
  },

  created() {
    this.initEligibilityTrack();
    // handleBenefitsEligibilty will be taken care by Apex
  },

  watch: {
    setDisplayInformation(val) {
      if (val === 'carousel') {
        this.displayInfo = false;
      }
    }
  }
});
</script>
